// 商品名の折れ方を、Safari・Firefox でも語の切れ目にそろえる（2026-09-30）。
// Chrome・Edge は word-break: auto-phrase で語の切れ目で折るので、ここでは何もしない（下の CSS.supports で抜ける）。
// Safari・Firefox では、add.css が <wbr> のある商品名だけ keep-all にして、<wbr> と半角の空白の所だけで折る。
// snippets/sc-title-wbr.liquid がよく出る語の前に <wbr> を入れているが、それで足りない所にここで <wbr> を足す:
//   1. 字の種類が変わる所（カタカナ・漢字・英数字の間と、ひらがなの後のカタカナ）: 「DREX|モイスト」「ミスト|化粧水」「うるおう|タイプ」
//   2. 記号の所（keep-all は全角の空白や括弧の所でも折れないため）: 開き括弧の前、閉じ括弧・全角の空白・「・、！？＆：／」の後、対の「〜」の外側
//   3. 半角の空白の後（空白で分かれた商品名も keep-all にして、「歯磨|き粉」のように語の途中で折らないため）
// 切らない所: 数字の後の助数詞（15包・2本）、1字だけの英字の前（ビタミンC）、「咲くらクリニック」の中、ー・小さい字の前、
//   最後の2字だけが次の行に行く所（…クリーム|MD）。
// BudouX（文節で区切る機械学習のモデル）も試したが、商品名では語の途中の改行が減らず、「うる|おう」のように語の中を切るため使わない。
// 測り方と結果は DESIGN.md の Phrase Wrap Rule。ES2019まで（テーマの他のJSに合わせる）。
(function (root, factory) {
  if (typeof module === 'object' && module.exports) {
    module.exports = factory();
  } else {
    root.ScPhraseWrap = factory();
  }
})(typeof window !== 'undefined' ? window : this, function () {
  'use strict';

  var KATA = /[ァ-ヺー-ヾｦ-ﾟ]/;
  var HIRA = /[ぁ-ゟ]/;
  var KANJI = /[㐀-鿿々-〇]/;
  var LATIN = /[A-Za-z0-9０-９Ａ-Ｚａ-ｚⅠ-ⅿ]/;
  var DIGIT = /[0-9０-９]/;
  var SPACE = /\s/;
  // 行の頭に来てはいけない字（ー・小さい字・繰り返しの記号）
  var NO_START = /[ーぁぃぅぇぉっゃゅょゎゕゖァィゥェォッャュョヮヵヶ々ゝゞヽヾ゛゜]/;
  var OPEN = '（(【「『［[〈《〔｛{';
  var CLOSE = '）)】」』］]〉》〕｝}';
  var AFTER = '　・、！？＆&：／/･';
  var NO_AFTER = '・、。！？';
  var WAVE = '〜～';
  var KEEP = ['咲くらクリニック'];
  var SEL = '.product-card__title, .product__block--title h1.product__title, .p-homeClinic__name, .c-priceList__table tbody th, .cart-item__title, .sticky-atc-bar__product-title, .search__results .text-pcard-title';
  var MARK = 'sc-pw';

  function kind(c) {
    if (!c) return '';
    if (KATA.test(c)) return 'K';
    if (HIRA.test(c)) return 'H';
    if (KANJI.test(c)) return 'J';
    if (LATIN.test(c)) return 'L';
    return '';
  }

  function inKeep(s, i) {
    for (var k = 0; k < KEEP.length; k++) {
      var j = s.indexOf(KEEP[k]);
      while (j >= 0) {
        if (i > j && i < j + KEEP[k].length) return true;
        j = s.indexOf(KEEP[k], j + 1);
      }
    }
    return false;
  }

  // 字の種類が変わる所で切ってよいか（i の字の前）
  function letterBreak(s, i) {
    var prev = s.charAt(i - 1);
    var c = s.charAt(i);
    var a = kind(prev);
    var b = kind(c);
    if (!a || !b || a === b) return false;
    if (a === 'H' ? b !== 'K' : b === 'H') return false;
    if (NO_START.test(c) || DIGIT.test(prev)) return false;
    // 「2ヶ月」「3ヵ所」「2ケ月」の中では切らない
    if (/[ヶヵ]/.test(prev) || (prev === 'ケ' && DIGIT.test(s.charAt(i - 2)))) return false;
    if (b === 'L' && kind(s.charAt(i + 1)) !== 'L') return false;
    return !inKeep(s, i);
  }

  // 記号・空白の所で切ってよいか（i の字の前）
  function markBreak(s, i) {
    var prev = s.charAt(i - 1);
    var c = s.charAt(i);
    // 空白の後の開き括弧の前にも入れる（全角の空白は keep-all では折れない。半角の空白は元から折れるが、3. と同じく keep-all にするため）
    if (OPEN.indexOf(c) >= 0) return OPEN.indexOf(prev) < 0 && (prev === ' ' || prev === '　' || !SPACE.test(prev));
    if (CLOSE.indexOf(prev) >= 0 || AFTER.indexOf(prev) >= 0 || prev === ' ') {
      return CLOSE.indexOf(c) < 0 && !SPACE.test(c) && !NO_START.test(c) && NO_AFTER.indexOf(c) < 0;
    }
    return false;
  }

  // 商品名の文字（<wbr> で分かれた所もつないだ物）から、<wbr> を足す位置（その字の前）を小さい順に返す
  function points(s) {
    var first = s.search(/\S/);
    if (first < 0) return [];
    var last = s.length - 1;
    while (last > first && SPACE.test(s.charAt(last))) last--;
    var picked = {};
    var i;
    for (i = first + 1; i <= last; i++) {
      if (letterBreak(s, i) || markBreak(s, i)) picked[i] = true;
    }
    // 対の「〜」: 開く方の前と、閉じる方の後
    var waves = [];
    for (i = first; i <= last; i++) {
      if (WAVE.indexOf(s.charAt(i)) >= 0) waves.push(i);
    }
    for (i = 0; i + 1 < waves.length; i += 2) {
      var open = waves[i];
      var close = waves[i + 1] + 1;
      if (open > first && OPEN.indexOf(s.charAt(open - 1)) < 0 && !SPACE.test(s.charAt(open - 1))) picked[open] = true;
      if (close <= last && CLOSE.indexOf(s.charAt(close)) < 0 && !SPACE.test(s.charAt(close))) picked[close] = true;
    }
    // 最後の2字だけが次の行に行く所では切らない
    var out = [];
    for (var key in picked) {
      var pos = Number(key);
      var rest = 0;
      for (var j = pos; j <= last && rest < 3; j++) {
        if (!SPACE.test(s.charAt(j))) rest++;
      }
      if (rest >= 3) out.push(pos);
    }
    return out.sort(function (x, y) { return x - y; });
  }

  function wrap(el) {
    if (el.querySelector('wbr.' + MARK)) return;
    var walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, null);
    var nodes = [];
    var starts = [];
    var text = '';
    var n;
    while ((n = walker.nextNode())) {
      nodes.push(n);
      starts.push(text.length);
      text += n.data;
    }
    var pts = points(text);
    // 後ろから入れる（前の位置がずれない）。文字のかたまりの境目（既にある <wbr> の所など）には入れない
    for (var k = pts.length - 1; k >= 0; k--) {
      for (var j = nodes.length - 1; j >= 0; j--) {
        var off = pts[k] - starts[j];
        if (off > 0 && off < nodes[j].data.length) {
          var rest = nodes[j].splitText(off);
          var wbr = document.createElement('wbr');
          wbr.className = MARK;
          rest.parentNode.insertBefore(wbr, rest);
          break;
        }
        if (off >= 0) break;
      }
    }
  }

  function scan(node) {
    if (!node || node.nodeType !== 1) return;
    if (node.matches(SEL)) wrap(node);
    var list = node.querySelectorAll(SEL);
    for (var i = 0; i < list.length; i++) wrap(list[i]);
  }

  function start() {
    scan(document.body);
    if (typeof MutationObserver !== 'function') return;
    // カートの引き出し・検索の候補・おすすめなど、後から出る商品名にも入れる
    var observer = new MutationObserver(function (records) {
      for (var i = 0; i < records.length; i++) {
        var target = records[i].target;
        var host = target.nodeType === 1 && target.closest ? target.closest(SEL) : null;
        if (host) wrap(host);
        var added = records[i].addedNodes;
        for (var j = 0; j < added.length; j++) scan(added[j]);
      }
      // 自分で入れた <wbr> の分の知らせは捨てる
      observer.takeRecords();
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (typeof document !== 'undefined' && typeof window !== 'undefined') {
    var auto = window.CSS && CSS.supports && CSS.supports('word-break', 'auto-phrase');
    if (!auto) {
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', start);
      } else {
        start();
      }
    }
  }

  return { points: points };
});
